import { render, staticRenderFns } from "./FileBrowserNewTabBtn.vue?vue&type=template&id=a22b64d2"
import script from "./FileBrowserNewTabBtn.vue?vue&type=script&lang=ts"
export * from "./FileBrowserNewTabBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports